<div class="ig-panel">
  <section class="form-section">
    <h3 class="section-title">
      {{ "settings.integration.connectionSection" | translate }}
    </h3>

    @if (lastGoogleSync) {
      <div class="ig-status">
        <mat-icon>check_circle</mat-icon>
        <span>{{
          "settings.integration.google.lastSync"
            | translate: { lastGoogleSync: lastGoogleSyncFormatted }
        }}</span>
      </div>
    }

    <div class="ig-step-block">
      <p class="section-hint">
        {{ "settings.integration.google.installFromMarketplace" | translate }}
      </p>
      <div class="ig-toolbar">
        <button
          mat-stroked-button
          type="button"
          (click)="openGoogleWorkspaceMarketplace()"
        >
          <img src="assets/img/google.svg" alt="" class="ig-logo" />
          {{ "settings.integration.google.authorizeButton" | translate }}
        </button>
      </div>
      @if (!lastGoogleSync) {
        <div class="ig-banner">
          <mat-icon>info</mat-icon>
          <span>
            {{ "settings.integration.google.adminPermissionInfo" | translate }}
            <button
              type="button"
              class="ig-link"
              (click)="openNotifyAdminDialog()"
            >
              {{ "settings.integration.google.notifyAdminLink" | translate }}
            </button>
          </span>
        </div>
      }
    </div>

    <div class="ig-step-block">
      <p class="section-hint">
        {{ "settings.integration.google.syncEmployeeData" | translate }}
      </p>
      <div class="ig-toolbar">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="syncGoogle()"
          [disabled]="isGoogleSyncInProgress"
        >
          <mat-spinner
            *ngIf="isGoogleSyncInProgress"
            diameter="18"
            class="dc-btn-spinner"
          ></mat-spinner>
          <mat-icon *ngIf="!isGoogleSyncInProgress">sync</mat-icon>
          {{ "employee.sync-google" | translate }}
        </button>
      </div>
    </div>

    @if (showGoogleProgress) {
      <app-sync-progress-bar
        [syncStateId]="googleSyncStateId"
        [provider]="'GOOGLE'"
        (onClose)="closeGoogleProgress()"
        (onCompleted)="onGoogleSyncCompleted($event)"
      ></app-sync-progress-bar>
    }
  </section>

  @if (false) {
  <section class="form-section">
    <h3 class="section-title">
      {{ "settings.integration.google.serverSide.configurationTitle" | translate }}
    </h3>

    <div class="option-list">
      <mat-slide-toggle
        color="primary"
        [checked]="proxyEnabled && lastGoogleSync"
        (change)="toggleProxy($event.checked)"
      >
        {{ "settings.integration.google.serverSide.enableProxy" | translate }}
      </mat-slide-toggle>
      @if (proxyEnabled) {
        <mat-checkbox
          color="primary"
          [(ngModel)]="internalSignatureEnabled"
          (change)="toggleInternalSignature($event.checked)"
          [matTooltip]="
            'settings.integration.google.serverSide.internalSignatureTooltip'
              | translate
          "
          matTooltipPosition="above"
        >
          {{
            "settings.integration.google.serverSide.enableInternalSignature"
              | translate
          }}
        </mat-checkbox>
      }
    </div>

    @if (proxyEnabled) {
      <p class="section-hint">
        {{
          "settings.integration.google.serverSide.configurationDescription"
            | translate
        }}
      </p>

      <mat-accordion class="ig-steps" multi>
        <mat-expansion-panel [class.ig-step--done]="step1Completed">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "settings.integration.google.serverSide.step1Title" | translate
            }}</mat-panel-title>
            <mat-checkbox
              color="primary"
              [(ngModel)]="step1Completed"
              (change)="onStepChange()"
              (click)="$event.stopPropagation()"
            ></mat-checkbox>
          </mat-expansion-panel-header>
          <div class="ig-prose">
            <p>
              {{ "settings.integration.google.serverSide.step1Description" | translate }}
              <a href="https://admin.google.com/ac/apps/gmail/hosts" target="_blank" rel="noopener">{{
                "settings.integration.google.serverSide.step1LinkText" | translate
              }}</a>
            </p>
            <ul>
              <li>{{ "settings.integration.google.serverSide.step1Bullet1" | translate }}</li>
              <li>{{ "settings.integration.google.serverSide.step1Bullet2" | translate }}</li>
              <li>
                {{ "settings.integration.google.serverSide.step1Bullet3" | translate }}
                <div class="ig-copies">
                  <div class="ig-copy">
                    <span>IP</span>
                    <code>{{ proxyDNS }}</code>
                    <button type="button" mat-icon-button (click)="copyToClipboard(proxyDNS)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                  <div class="ig-copy">
                    <span>Port</span>
                    <code>{{ proxyPort }}</code>
                    <button type="button" mat-icon-button (click)="copyToClipboard(proxyPort)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                </div>
              </li>
              <li>{{ "settings.integration.google.serverSide.step1Bullet4" | translate }}</li>
            </ul>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [class.ig-step--done]="step2Completed">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "settings.integration.google.serverSide.step2Title" | translate
            }}</mat-panel-title>
            <mat-checkbox
              color="primary"
              [(ngModel)]="step2Completed"
              (change)="onStepChange()"
              (click)="$event.stopPropagation()"
            ></mat-checkbox>
          </mat-expansion-panel-header>
          <div class="ig-prose">
            <p>
              {{ "settings.integration.google.serverSide.step2Description" | translate }}
              <a href="https://admin.google.com/ac/apps/gmail/compliance" target="_blank" rel="noopener">{{
                "settings.integration.google.serverSide.step2LinkText" | translate
              }}</a>
            </p>
            <ul>
              <li>{{ "settings.integration.google.serverSide.step2Bullet1" | translate }}</li>
              <li>{{ "settings.integration.google.serverSide.step2Bullet2" | translate }}</li>
              <li>{{ "settings.integration.google.serverSide.step2Bullet3" | translate }}</li>
              <li>{{ "settings.integration.google.serverSide.step2Bullet4" | translate }}</li>
              <li>
                {{ "settings.integration.google.serverSide.step2Bullet5" | translate }}
                <ul>
                  <li>
                    {{ "settings.integration.google.serverSide.step2Bullet5Sub1" | translate }}
                    <ul>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub1Sub1" | translate }}</li>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub1Sub2" | translate }}</li>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub1Sub3" | translate }}</li>
                      <li>
                        {{ "settings.integration.google.serverSide.step2Bullet5Sub1Sub4" | translate }}
                        <div class="ig-copy">
                          <span>{{ "settings.integration.google.serverSide.proxySenderHeader" | translate }}</span>
                          <code>{{ xGSignature }}</code>
                          <button type="button" mat-icon-button (click)="copyToClipboard(xGSignature)">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li>
                    {{ "settings.integration.google.serverSide.step2Bullet5Sub2" | translate }}
                    <ul>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub2Sub1" | translate }}</li>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub2Sub2" | translate }}</li>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub2Sub3" | translate }}</li>
                      <li>
                        {{ "settings.integration.google.serverSide.step2Bullet5Sub2Sub4" | translate }}
                        <div class="ig-copy">
                          <span>{{ "settings.integration.google.serverSide.regex" | translate }}</span>
                          <code>{{ fromSenderRegex }}</code>
                          <button type="button" mat-icon-button (click)="copyToClipboard(fromSenderRegex)">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li>
                    {{ "settings.integration.google.serverSide.step2Bullet5Sub3" | translate }}
                    <ul>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub3Sub1" | translate }}</li>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub3Sub2" | translate }}</li>
                      <li>{{ "settings.integration.google.serverSide.step2Bullet5Sub3Sub3" | translate }}</li>
                      <li>
                        {{ "settings.integration.google.serverSide.step2Bullet5Sub3Sub4" | translate }}
                        <div class="ig-routing">
                          <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ "settings.integration.google.serverSide.routingEmailsLabel" | translate }}</mat-label>
                            <input
                              matInput
                              [(ngModel)]="routingEmails"
                              (input)="onRoutingEmailsChange()"
                              [disabled]="routingAllEmails"
                              placeholder="email1@example.com, email2@example.com"
                            />
                          </mat-form-field>
                          <mat-checkbox
                            color="primary"
                            [(ngModel)]="routingAllEmails"
                            (change)="onRoutingAllEmailsChange()"
                          >
                            {{ "settings.integration.google.serverSide.routingAllEmails" | translate }}
                          </mat-checkbox>
                          @if (generatedRegex) {
                            <div class="ig-copy">
                              <span>{{ "settings.integration.google.serverSide.regex" | translate }}</span>
                              <code>{{ generatedRegex }}</code>
                              <button type="button" mat-icon-button (click)="copyToClipboard(generatedRegex)">
                                <mat-icon>content_copy</mat-icon>
                              </button>
                            </div>
                          }
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>{{ "settings.integration.google.serverSide.step2Bullet6" | translate }}</li>
            </ul>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [class.ig-step--done]="step3Completed">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "settings.integration.google.serverSide.step3Title" | translate
            }}</mat-panel-title>
            <mat-checkbox
              color="primary"
              [(ngModel)]="step3Completed"
              (change)="onStepChange()"
              (click)="$event.stopPropagation()"
            ></mat-checkbox>
          </mat-expansion-panel-header>
          <div class="ig-prose">
            <p>
              {{ "settings.integration.google.serverSide.step3Description" | translate }}
              <a href="https://admin.google.com/ac/apps/gmail/routing" target="_blank" rel="noopener">{{
                "settings.integration.google.serverSide.step3LinkText" | translate
              }}</a>
            </p>
            <ul>
              <li>{{ "settings.integration.google.serverSide.step3Bullet1" | translate }}</li>
              <li>{{ "settings.integration.google.serverSide.step3Bullet2" | translate }}</li>
              <li>{{ "settings.integration.google.serverSide.step3Bullet3" | translate }}</li>
              <li>{{ "settings.integration.google.serverSide.step3Bullet4" | translate }}</li>
              <li>
                {{ "settings.integration.google.serverSide.step3Bullet5" | translate }}
                <div class="ig-copy">
                  <span>IP</span>
                  <code>{{ proxyHostIp }}</code>
                  <button type="button" mat-icon-button (click)="copyToClipboard(proxyHostIp)">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel
          [class.ig-step--done]="step4Completed"
          [class.ig-step--error]="!spfCheckResult"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "settings.integration.google.serverSide.step4Title" | translate
            }}</mat-panel-title>
            <mat-checkbox
              color="primary"
              [(ngModel)]="step4Completed"
              [disabled]="true"
              (click)="$event.preventDefault(); $event.stopPropagation()"
            ></mat-checkbox>
          </mat-expansion-panel-header>
          <div class="ig-prose">
            <p>
              {{ "settings.integration.google.serverSide.step4Description" | translate }}
              <a href="https://support.google.com/a/answer/33786" target="_blank" rel="noopener">(link)</a>
            </p>
            <div class="ig-note">
              <p>{{ "settings.integration.google.serverSide.step4Example" | translate }}</p>
              <code>{{ proxySPF }}</code>
            </div>
            <button mat-raised-button color="primary" type="button" (click)="verifySpfRecord()">
              {{ "settings.integration.google.serverSide.checkSpfButton" | translate }}
            </button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

    }

    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="saveIntegrationSettings()"
        [disabled]="!canSaveServerSide"
        [class.loading-button]="savingProxy"
      >
        <mat-spinner
          *ngIf="savingProxy"
          diameter="18"
          class="dc-btn-spinner"
        ></mat-spinner>
        <mat-icon *ngIf="!savingProxy">save</mat-icon>
        {{ savingProxy ? ("saving" | translate) : ("save" | translate) }}
      </button>
    </div>
  </section>
  }

  <section class="form-section">
    <h3 class="section-title">
      {{ "settings.integration.google.absence.title" | translate }}
    </h3>
    <p class="section-hint">
      {{ "settings.integration.google.absence.description" | translate }}
    </p>
    <div class="option-list">
      <mat-checkbox
        color="primary"
        [checked]="absenceEnabled && lastGoogleSync"
        (change)="toggleAbsence($event.checked)"
        [class.conflict-disabled]="otherAbsenceEnabled"
        [matTooltip]="
          otherAbsenceEnabled
            ? ('settings.integration.calamari.absence.conflictCalamari' | translate)
            : ''
        "
        [matTooltipDisabled]="!otherAbsenceEnabled"
      >
        {{ "settings.absenceEnabled" | translate }}
      </mat-checkbox>
    </div>
    @if (absenceEnabled) {
      <div class="field-row">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "settings.absenceLabel" | translate }}</mat-label>
          <input matInput [(ngModel)]="absenceLabel" (input)="onAbsenceLabelChange()" type="text" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "settings.integration.google.absence.daysAhead" | translate }}</mat-label>
          <mat-select [(ngModel)]="absenceDaysAhead" (selectionChange)="onAbsenceDaysAheadChange()">
            @for (day of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60]; track day) {
              <mat-option [value]="day">
                {{ day }} {{ "settings.integration.google.absence.days" | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="saveIntegrationSettings()"
        [disabled]="savingProxy || !hasChanges"
      >
        <mat-spinner *ngIf="savingProxy" diameter="18" class="dc-btn-spinner"></mat-spinner>
        <mat-icon *ngIf="!savingProxy">save</mat-icon>
        {{ savingProxy ? ("saving" | translate) : ("save" | translate) }}
      </button>
    </div>
  </section>
</div>
